import React, { memo, useContext } from 'react'

import { Icon, ErrorOutlined, Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import GenerateButton from 'Pods/ThreeDStudio/Shared/GenerateArea/Components/GenerateButton/GenerateButton'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

import { capitalizeFirst } from 'Utils/capitalizeFirst'

import DetailRow from './Components/DetailRow/DetailRow'

function ErrorBannerState() {
  const errorId = useThreeDStudioStore(state => state.generation.errorId)
  const errorDetails = useThreeDStudioStore(state => state.generation.errorDetails)
  const activeViewerSidebarTab = useThreeDStudioStore(state => state.ui?.activeViewerSidebarTab)
  const { showGenerationErrorDetails } = useContext(ThreeDStudioPageContext)
  const buttonLabel = `${capitalizeFirst(activeViewerSidebarTab || "generate")} Again`

  const { failureReason, failureMessage, providerErrorCode } = errorDetails || {}
  const hasErrorDetails = Boolean(failureReason || failureMessage || providerErrorCode)
  const shouldShowDetails = showGenerationErrorDetails && hasErrorDetails

  return (
    <div className="error-banner">
      <div className="error-banner__content">
        <div className="error-banner__icon-wrapper">
          <Icon
            svgComponent={ErrorOutlined}
            className="error-banner__icon"
            notSpaced
            withHover={false}
          />
        </div>
        <span className="cgt-heading-300 cgt-mb-12 error-banner__title">Something went wrong</span>
        <span className="error-banner__description">
          We couldn't complete this action. Try adjusting settings, simplifying your input, or checking references.
        </span>
        {(errorId || shouldShowDetails) && (
          <div className="error-banner__error-wrapper">
            {errorId && (
              <DetailRow label="ERROR ID" pill>#{errorId}</DetailRow>
            )}
            {shouldShowDetails && (
              <>
                {failureReason && <DetailRow label="REASON">{failureReason}</DetailRow>}
                {failureMessage && <DetailRow label="MESSAGE">{failureMessage}</DetailRow>}
                {providerErrorCode && <DetailRow label="PROVIDER CODE">{providerErrorCode}</DetailRow>}
              </>
            )}
          </div>
        )}

        <div className="error-banner__actions">
          {/* TODO: Add report issue button */}
          {/* <Button type="secondary" size="small" customClass="error-banner__report-button">
            Report Issue
          </Button> */}
          <GenerateButton
            generateLabel={buttonLabel}
            generatedLabel={buttonLabel}
            generatingLabel={buttonLabel}
            withIcon={false}
          />
        </div>
      </div>
    </div>
  )
}

export default memo(ErrorBannerState)
